module.exports = __webpack_public_path__ + "static/img/A58.07f5f0b5.jpg";